import * as React from 'react';
import { warnOnce } from '../common.js';

function useWarnOnDeprecatedProps(version, displayName, deprecations, args) {
  const deprecationRef = React.useRef(deprecations);
  React.useEffect(() => {
    for (const key of Object.keys(args[0])) {
      if (Object.keys(deprecationRef.current).includes(key) && key !== void 0) {
        const advice = deprecationRef.current[key];
        let warning = `The "${key}" prop on ${displayName} has been deprecated in version ${version}`;
        if (advice) {
          warning += "\n" + advice;
        }
        warnOnce(warning);
      }
    }
  }, [args, displayName, version]);
}

export { useWarnOnDeprecatedProps };
